import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { X } from "@phosphor-icons/react";

export default function Approvals() {
    const { t } = useI18n();
    const [items, setItems] = useState([]);
    const [params, setParams] = useSearchParams();
    const gov = params.get("gov");
    useEffect(() => {
        const build = (status) => {
            const p = { status };
            if (gov) p.gov = gov;
            return api.get("/applications", { params: p });
        };
        Promise.all([build("submitted"), build("under_review")])
            .then(([a, b]) => setItems([...a.data.applications, ...b.data.applications]));
    }, [gov]);
    return (
        <div className="space-y-6" data-testid="approvals-page">
            <div>
                <div className="text-[11px] tracking-[0.35em] uppercase text-primary">· PENDING</div>
                <h1 className="text-3xl font-bold tracking-tight mt-1">{t("approvals")}</h1>
            </div>
            {gov && (
                <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-primary/10 border border-primary/30 text-primary rounded-sm text-xs uppercase tracking-widest" data-testid="approvals-gov-badge">
                    Governorate: {gov}
                    <button onClick={() => setParams({})} className="ms-1"><X size={12} weight="bold" /></button>
                </div>
            )}
            <Card className="rounded-sm border-border overflow-hidden">
                <table className="w-full data-grid text-sm">
                    <thead className="bg-secondary text-xs uppercase tracking-widest">
                        <tr>
                            <th className="text-start">{t("reference")}</th>
                            <th className="text-start">{t("ownerName")}</th>
                            <th className="text-start">{t("vin")}</th>
                            <th className="text-start">{t("status")}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.length === 0 && <tr><td colSpan={5} className="text-center py-10 text-muted-foreground">{t("noData")}</td></tr>}
                        {items.map((a) => (
                            <tr key={a.id} className="border-t border-border" data-testid={`approval-row-${a.id}`}>
                                <td className="mono">{a.reference}</td>
                                <td>{a.owner?.full_name}</td>
                                <td className="mono">{a.vehicle?.vin}</td>
                                <td className="uppercase text-xs tracking-widest">{a.status}</td>
                                <td className="text-end">
                                    <Link to={`/app/applications/${a.id}`}>
                                        <Button size="sm" data-testid={`approval-review-${a.id}`}>{t("view")}</Button>
                                    </Link>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </Card>
        </div>
    );
}
